import { UitkEGMapsQualifier } from 'uitk-react-map';

import { FeatureStatus, FeatureType } from '@eg-maps/core';

interface FeatureDef {
  type: FeatureType;
  status: FeatureStatus;
  qualifiers?: string[];
}

export const iconMap: Record<string, FeatureDef> = {
  AIRPORT: {
    type: 'place',
    qualifiers: [UitkEGMapsQualifier.AIRPORT],
    status: 'unknown',
  },
  SOLD_OUT: {
    type: 'property',
    qualifiers: [UitkEGMapsQualifier.NOT_CLUSTERED],
    status: 'sold_out',
  },
  LANDMARK: {
    type: 'place',
    status: 'unknown',
  },
  HOTEL: {
    type: 'property',
    status: 'available',
  },
};
